import { ArticleConfiguration } from "lib/@types/service/cart/shared";
import { MainImage } from "lib/@types/service/shared";

import { ProductImageRenditions } from "./enums";

export const getMedias = (
    isWarrentyDeposit: boolean,
    title?: string,
    mainImages?: Array<MainImage> | null,
    articleConfiguration?: ArticleConfiguration | null,
) => {
    if (isWarrentyDeposit) {
        return null;
    }

    if (articleConfiguration) {
        return [
            {
                url: articleConfiguration.imageURL || "",
                format: ProductImageRenditions.SM,
                altText: title,
            },
        ];
    }

    return mainImages?.[0]?.medias || [];
};
